import DynamicService from '@/service/DynamicService';
import VariationSchema from '../schemas/VariationSchema';

const formatResponse = () => {
};

const VariationsService = DynamicService('variations', VariationSchema, { formatResponse });

export default VariationsService;